import React from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import EndorsementStatusForm from '../../../components/forms/EndorsementStatusForm';
import { useEndorsementStatusById, useUpdateEndorsementStatus } from '../../../hooks/useEndorsementStatusApi';
import { useNavigate, useParams } from 'react-router-dom';

const EndorsementStatusEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: entityData } = useEndorsementStatusById(id);
  const updateMutation = useUpdateEndorsementStatus();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Endorsement Statuses', href: '/admin/endorsementstatuses' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      await updateMutation.mutateAsync({ id: id!, data });
      navigate('/admin/endorsementstatuses');
    } catch (error) {
      console.error('Error updating EndorsementStatus:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/endorsementstatuses"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.EndorsementStatus.Edit"
    >
        {entityData ? (
          <EndorsementStatusForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/endorsementstatuses')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default EndorsementStatusEdit;
